<template>
    <p class="mb-5 text-base md:text-lg" :class="[ options.color || '']">
        <slot></slot>
    </p>
</template>

<script>
    export default {
        name: 'Paragraph',
        props: {
            options: null
        }
    };
</script>

<style lang="scss" scoped>

</style>
